import { useEffect } from "react";

import { useLocation } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";

export const usePostHogTrackPageView = () => {
  const posthog = usePostHog();

  const location = useLocation();

  useEffect(() => {
    if (posthog) {
      posthog.capture("$pageview", {
        $current_url: window.origin + location.pathname,
      });
    }
  }, [posthog, location.pathname]);
};
